import { render, staticRenderFns } from "./CategoryCollection.vue?vue&type=template&id=706474ec&"
import script from "./CategoryCollection.vue?vue&type=script&lang=js&"
export * from "./CategoryCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports